import { isNullOrUndefined } from "../../../common/utils";
import { Conjunction, Disjunction, Negation } from "../model/ComplexCondition";
import { Operators } from "../model/Operators";
import {
  ArrayContains,
  Equality,
  NullCondition,
  RegexMatch,
  SpecialEquality, StringIn,
} from "../model/SimpleCondition";

export function createConditionTree(condition, parent) {
  if (isNullOrUndefined(condition)) {
    return null;
  }
  switch (condition.operator) {
    case Operators.comparisonARRAY_CONTAINS:
      return new ArrayContains(condition, parent);
    case Operators.comparisonREGEX_MATCH:
      return new RegexMatch(condition, parent);
    case Operators.comparisonEQ:
      return new Equality(condition, parent);
    case Operators.comparisonSTRING_IN:
      return new StringIn(condition, parent);
    case Operators.comparisonSPECIAL_EQ:
      return new SpecialEquality(condition, parent);
    case Operators.logicalAND:
      return new Conjunction(condition, parent);
    case Operators.logicalOR:
      return new Disjunction(condition, parent);
    case Operators.logicalNOT:
      return new Negation(condition, parent);
    case Operators.noConditionNull:
      return new NullCondition(condition, parent);
    default:
      return null;
  }
}
